import React, { useState } from "react";
import {
  Card,
  Table,
  Typography,
  Space,
  Button,
  Input,
} from "antd";

const { Title, Paragraph } = Typography;
const { Search } = Input;

/* ---------------- DATA ---------------- */

const isoData = [
  {
    key: 1,
    description: "3CX v20 Debian12 (amd64)",
    id: "100686",
    name: "debian-amd64-netinst-3cx-v20.iso",
  },
  {
    key: 2,
    description: "AlmaLinux 9.6 (amd64/boot)",
    id: "122879",
    name: "AlmaLinux-9.6-x86_64-boot.iso",
  },
  {
    key: 3,
    description: "AlmaLinux 10.0 (amd64/boot)",
    id: "122884",
    name: "AlmaLinux-10.0-x86_64-boot.iso",
  },
  {
    key: 4,
    description: "Alpine Virtual 3.22.2 (x86_64)",
    id: "122881",
    name: "alpine-virt-3.22.2-x86_64.iso",
  },
  {
    key: 5,
    description: "Archlinux 2025.01.01 (amd64)",
    id: "122882",
    name: "archlinux-2025.01.01-x86_64.iso",
  },
  {
    key: 6,
    description: "CentOS Stream 10",
    id: "119810",
    name: "CentOS-Stream-10-latest-x86_64-dvd1.iso",
  },
  {
    key: 7,
    description: "Clonezilla 3.3.0-33 (amd64/live)",
    id: "122805",
    name: "clonezilla-live-3.3.0-33-amd64.iso",
  },
  {
    key: 8,
    description: "Debian 12.10 (amd64/netinst)",
    id: "118933",
    name: "debian-12.10.0-amd64-netinst.iso",
  },
  {
    key: 9,
    description: "Debian 13.0 (amd64/netinst)",
    id: "122886",
    name: "debian-13.0.0-amd64-netinst.iso",
  },
  {
    key: 10,
    description: "Fedora 43 (netinst/amd64)",
    id: "123164",
    name: "Fedora-Everything-netinst-x86_64-43-1.6.iso",
  },
];

/* ---------------- COLUMNS ---------------- */

const columns = [
  {
    title: "DESCRIPTION",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "NAME",
    dataIndex: "name",
    key: "name",
  },
  {
    key: "action",
    align: "right",
    render: () => (
      <Button danger type="primary" size="small">
        Mount
      </Button>
    ),
  },
];

/* ---------------- COMPONENT ---------------- */

export default function IsoImages() {
  const [query, setQuery] = useState("");

  const filteredData = isoData.filter(
    (item) =>
      item.description.toLowerCase().includes(query.toLowerCase()) ||
      item.name.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      {/* INFO CARD */}
      <Card>
        <Title level={5}>ISO IMAGES</Title>

        <Paragraph>
          Mounting an ISO Image will attach it to the virtual drive
          in your server.
        </Paragraph>

        <Paragraph>
          Rebooting your server while an ISO image is mounted will
          cause it to boot from the image. After rebooting the server
          you can access our web console to complete the installation.
        </Paragraph>

        <Paragraph>
          If you want to use your own ISO image, please follow the
          instructions in our Docs.
        </Paragraph>
      </Card>

      {/* TABLE */}
      <Card
        title="AVAILABLE IMAGES"
        extra={
          <Search
            placeholder="Search"
            allowClear
            onChange={(e) => setQuery(e.target.value)}
            style={{ width: 220 }}
          />
        }
      >
        <Table
          columns={columns}
          dataSource={filteredData}
          pagination={{ pageSize: 10 }}
        />
      </Card>
    </Space>
  );
}
